import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from '../carrier/response-container';
import { environment } from "../../environments/environment";
import { timeout, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { QCPositionPlacementRequest } from './qc-position-placement-request';


@Injectable({
  providedIn: 'root'
})
export class QuadrantViewService {

  defaultTimeout = 600000;
  constructor(private http: HttpClient) { }

  deleteCurrentPlate(containerBarcode: string) {
    console.log("Delete the current plate " + containerBarcode)
    return this.http.delete<BBResponseContainer>(environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/' + containerBarcode)
  }

  getStorageAndPrimerBarcodeForReactionPlate(selectedPlateBarcode: string) {
    let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/listOfDNAAndPrimerPlates';
    let requestParam = new HttpParams().set('plateBarcode', selectedPlateBarcode);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
      error.url = url;
    }));

  }

      /**
     * @description Place qc positions on reaction plate
     * @param qcRequest
     */
    placeQcReactionPositions(qcRequest: QCPositionPlacementRequest): Observable<BBResponseContainer> {
      let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/placeQCReactionsAutomatically';
      return this.http.post<BBResponseContainer>(url, qcRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
          error.url = url;
      }));
  }
}
